import { CombinedError } from 'urql';

import * as E from 'fp-ts/Either';
import * as A from 'fp-ts/Array';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/lib/function';
import { Validation } from '../generated/graphql';

interface ValidatedResponse {
  validation?: Validation[] | null;
}

/**
 * Creates a function that takes the response data of a mutation that might have
 * validation errors and returns an appropriate message encapsulatied in a
 * result monad.
 *
 * @param successMessage The message to return if the mutation was a success
 */
export const buildMutationMessage =
  (successMessage: string = 'Success 🎉') =>
  (
    data?: ValidatedResponse | null,
    error?: CombinedError,
  ): E.Either<string, string> => {
    if (error) {
      return E.left(error.message);
    }

    if (data && data.validation) {
      return pipe(
        A.head(data.validation),
        O.fold(
          () => E.left('Something went wrong with this request'),
          (error) => E.left(`${error.key} ${error.reason}`),
        ),
      );
    }
    return E.right(successMessage);
  };
